import React from 'react';
import "../Styles/App.css"

export function PPL() {
  return (
    <div className="article-writeup">
    <h1>Privacy Policy</h1>
    <p><strong>Effective Date:</strong> 17 March 2025</p>
    
    <h2>1. Introduction</h2>
    <p>Welcome to Radikle AI ("we," "our," or "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal data when you use our application.</p>
    
    <h2>2. Information We Collect</h2>
    <ul>
        <li><strong>Personal Information:</strong> Name, email address, phone number, and other details provided by you.</li>
        <li><strong>Usage Data:</strong> Information about how you interact with our app, including IP address, browser type, and device details.</li>
        <li><strong>Cookies and Tracking Technologies:</strong> Data collected through cookies and similar technologies to enhance user experience.</li>
    </ul>
    
    <h2>3. How We Use Your Information</h2>
    <ul>
        <li>To provide, operate, and improve our services.</li>
        <li>To personalize user experience.</li>
        <li>To provide customer support and respond to inquiries.</li>
        <li>To maintain security and prevent fraud.</li>
        <li>To comply with legal obligations.</li>
    </ul>
    
    <h2>4. Sharing of Information</h2>
    <p>We do not sell your personal data. We may share your information with:</p>
    <ul>
        <li>Third-party service providers for analytics, hosting, and security.</li>
        <li>Legal authorities if required by law.</li>
        <li>Business partners to improve services (only with your consent where necessary).</li>
    </ul>
    
    <h2>5. Data Security</h2>
    <p>We implement industry-standard security measures to protect your data from unauthorized access, alteration, and misuse. However, no method of transmission over the internet is 100% secure.</p>
    
    <h2>6. User Rights</h2>
    <p>Depending on your location, you may have the following rights regarding your personal data:</p>
    <ul>
        <li>Access, update, or delete your data.</li>
        <li>Object to processing or withdraw consent.</li>
        <li>Request a copy of your personal data.</li>
    </ul>
    <p>To exercise these rights, contact us at <strong>admin@radikle.com</strong>.</p>
    
    <h2>7. Cookies and Tracking</h2>
    <p>We use cookies to enhance user experience. You can disable cookies through your browser settings, but some app features may not function properly.</p>
    
    <h2>8. Changes to This Privacy Policy</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>
    
    <h2>9. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
    <p><strong>info@radikle.com</strong>.</p>
</div>
  )
}
